(function () {
  var storageKey = 'aeliza-theme-mode';
  var root = document.documentElement;
  var sizeChartObserver;

  function getDefaultMode() {
    return 'dark';
  }

  function getStoredMode() {
    try {
      var storedMode = window.localStorage.getItem(storageKey);
      return storedMode === 'light' || storedMode === 'dark' ? storedMode : null;
    } catch (error) {
      return null;
    }
  }

  function getMode() {
    var currentMode = root.getAttribute('data-theme');
    if (currentMode === 'light' || currentMode === 'dark') return currentMode;
    return getStoredMode() || getDefaultMode();
  }

  function setMode(mode, persist) {
    var nextMode = mode === 'light' ? 'light' : 'dark';
    root.setAttribute('data-theme', nextMode);

    if (persist) {
      try {
        window.localStorage.setItem(storageKey, nextMode);
      } catch (error) {}
    }

    document.querySelectorAll('.theme-mode-toggle').forEach(function (button) {
      button.setAttribute('aria-label', 'Switch to ' + (nextMode === 'dark' ? 'light' : 'dark') + ' mode');
      button.setAttribute('aria-pressed', nextMode === 'light' ? 'true' : 'false');
    });
  }

  function mountThemeFixes() {
    if (document.getElementById('aeliza-theme-fixes')) return;

    var style = document.createElement('style');
    style.id = 'aeliza-theme-fixes';
    style.textContent = [
      '[data-theme="dark"] .site-header img[alt*="AELIZA" i],',
      '[data-theme="dark"] header img[alt*="AELIZA" i],',
      '[data-theme="dark"] .site-header__logo img,',
      '[data-theme="dark"] .site-logo img,',
      '[data-theme="dark"] .header__logo img,',
      '[data-theme="dark"] header a[href="/"] img { filter: brightness(0) invert(1) !important; }',
      '[data-theme="light"] .site-header img[alt*="AELIZA" i],',
      '[data-theme="light"] header img[alt*="AELIZA" i],',
      '[data-theme="light"] .site-header__logo img,',
      '[data-theme="light"] .site-logo img,',
      '[data-theme="light"] .header__logo img,',
      '[data-theme="light"] header a[href="/"] img { filter: brightness(0) !important; }',
      '.site-header__logo, .site-logo, .header__logo, header a[href="/"] { color: var(--aeliza-text) !important; }',
      '.site-header__logo svg *, .site-logo svg *, .header__logo svg *, header a[href="/"] svg * { fill: currentColor !important; stroke: currentColor !important; }',
      'html[data-theme="light"] .aeliza-announcement { background: #000000 !important; color: #ffffff !important; border-bottom-color: #ffffff !important; }',
      'html[data-theme="light"] .aeliza-announcement__item { color: #ffffff !important; }',
      '.product-main__info > .product-option:last-of-type { margin-bottom: 24px !important; }',
      '.product-option__value { border: 1px solid var(--aeliza-text) !important; }'
    ].join('\n');

    document.head.appendChild(style);
  }

  function positionSizeChartWrapper() {
    var info = document.querySelector('.product-main__info');
    if (!info) return;

    var wrapper = info.querySelector('.pify_size_chart_wrapper');
    var firstOption = info.querySelector('.product-option');

    if (wrapper && firstOption && wrapper.nextElementSibling !== firstOption) {
      firstOption.parentNode.insertBefore(wrapper, firstOption);
    }
  }

  function observeSizeChart() {
    positionSizeChartWrapper();

    if (sizeChartObserver || !document.body) return;

    sizeChartObserver = new MutationObserver(function () {
      positionSizeChartWrapper();
    });

    sizeChartObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function makeToggle(modifier) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'theme-mode-toggle theme-mode-toggle--' + modifier;
    button.innerHTML = '<span class="theme-mode-toggle__label theme-mode-toggle__label--dark">DARK</span><span class="theme-mode-toggle__divider" aria-hidden="true">/</span><span class="theme-mode-toggle__label theme-mode-toggle__label--light">LIGHT</span>';
    button.addEventListener('click', function () {
      setMode(getMode() === 'dark' ? 'light' : 'dark', true);
    });
    return button;
  }

  function makeReflectionIndexLink() {
    var link = document.createElement('a');
    link.href = '/pages/self-reflection';
    link.className = 'mobile-nav__link mobile-nav__link--reflection-index';
    link.textContent = 'THE REFLECTION INDEX';
    return link;
  }

  function mountToggles() {
    mountThemeFixes();

    var desktopActions = document.querySelector('.site-nav__right');
    if (desktopActions && !desktopActions.querySelector('.theme-mode-toggle--desktop')) {
      desktopActions.insertBefore(makeToggle('desktop'), desktopActions.firstChild);
    }

    var mobileList = document.querySelector('.mobile-nav__list');
    if (mobileList && !mobileList.querySelector('.mobile-nav__link--reflection-index, a[href="/pages/self-reflection"]')) {
      var reflectionItem = document.createElement('li');
      reflectionItem.className = 'mobile-nav__item mobile-nav__item--reflection-index';
      reflectionItem.appendChild(makeReflectionIndexLink());
      mobileList.appendChild(reflectionItem);
    }

    if (mobileList && !mobileList.querySelector('.theme-mode-toggle--mobile')) {
      var item = document.createElement('li');
      item.className = 'mobile-nav__item mobile-nav__item--theme-mode';
      item.appendChild(makeToggle('mobile'));
      mobileList.appendChild(item);
    }

    setMode(getMode(), false);
    observeSizeChart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountToggles);
  } else {
    mountToggles();
  }

  document.addEventListener('shopify:section:load', function () {
    mountToggles();
    positionSizeChartWrapper();
  });
})();
